import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Multiseaterbuses() {



    const cardData = {

keyword: "32,35,40,45,50 Seater Bus on Rent in Pune",

headingDescription:
    "Rising Cab Service offers safe, reliable, and comfortable 32, 35, 40, 45, and 50 Seater Bus on Rent in Pune for large group travel including corporate outings, wedding transportation, school trips, college tours, pilgrimage journeys, and outstation tours. Our fleet includes well-maintained AC luxury buses with push-back seats, spacious interiors, music systems, luggage space, and experienced professional drivers for long-distance highway travel. With doorstep pickup across Pune, flexible rental packages, 24/7 support, and transparent pricing, we ensure a smooth and hassle-free group travel experience for all occasions.",

topPlaces: [

    {
        title: "Ashtavinayak Darshan Circuit",
        description:
            "The Ashtavinayak pilgrimage includes eight sacred Ganpati temples across Maharashtra. Large buses are ideal for group spiritual tours, ensuring smooth, organized, and comfortable travel for devotees completing the holy circuit from Pune."
    },
    {
        title: "Nashik & Trimbakeshwar Jyotirlinga",
        description:
            "Nashik is a spiritual city known for Trimbakeshwar Jyotirlinga, Panchavati temples, and vineyards. Large buses are suitable for pilgrimage groups, school tours, and corporate trips combining religious and leisure experiences from Pune."
    },
    {
        title: "Goa Group Beach Tour",
        description:
            "Goa is a long-distance destination famous for beaches, nightlife, and adventure activities. Large buses are perfect for wedding groups, corporate tours, and friends’ vacations traveling together from Pune for a comfortable beach holiday experience."
    },
    {
        title: "Alibaug Coastal Group Trip",
        description:
            "Alibaug is a coastal destination near Mumbai known for beaches, forts, and water sports. Large buses are ideal for group outings, corporate picnics, and school tours from Pune for a relaxed beachside experience."
    },
        {
        title: "Lonavala & Khandala Group Tour",
        description:
            "Lonavala and Khandala are the most popular hill stations near Pune, known for lush green valleys, waterfalls, and scenic viewpoints. Large buses are ideal for corporate groups, school trips, and wedding outings to enjoy monsoon beauty and weekend travel together in comfort and coordination."
    },
    {
        title: "Mahabaleshwar & Panchgani Tour",
        description:
            "Mahabaleshwar and Panchgani are famous hill stations known for strawberries, viewpoints, lakes, and cool climate. Large buses are perfect for group travel, ensuring families, schools, and corporate teams can explore multiple attractions together in a comfortable journey."
    },
    {
        title: "Shirdi Sai Baba Darshan",
        description:
            "Shirdi is one of the most important pilgrimage destinations in Maharashtra dedicated to Sai Baba. Large buses are widely used for group darshan tours, providing comfortable seating and coordinated travel for devotees from Pune visiting the holy shrine."
    },
    {
        title: "Bhimashankar Jyotirlinga Visit",
        description:
            "Bhimashankar is a sacred Jyotirlinga temple located in the Sahyadri hills surrounded by forests. Large buses ensure safe and comfortable travel for big pilgrimage groups and nature-loving travelers from Pune."
    },
    {
        title: "Aurangabad Heritage Tour",
        description:
            "Aurangabad is famous for Ajanta and Ellora Caves, UNESCO World Heritage Sites. Large buses are widely used for educational trips, cultural tours, and heritage travel groups from Pune exploring historical landmarks."
    },
    {
        title: "Konkan Coastal Group Tour",
        description:
            "The Konkan coast including Ganpatipule, Diveagar, and Tarkarli offers scenic beaches and greenery. Large buses are perfect for group vacations, ensuring comfortable long-distance travel for families, schools, and corporate teams from Pune."
    }
],



services: [
{
name: "32 Seater Bus Hire Near Me in Pune",
description: "Rising Cab Service offers 32 Seater Bus Hire Near Me in Pune for family tours, corporate travel, weddings, school trips, religious tours, and outstation journeys. Our 32 seater buses are equipped with comfortable pushback seats, spacious interiors, air-conditioning options, ample luggage space, and experienced drivers. We provide safe, affordable, and reliable transportation with flexible rental packages, doorstep pickup, and 24x7 booking support for group travel requirements."
},
{
name: "32 Seater Bus Hire for Outstation in Pune",
description: "Book 32 Seater Bus Hire for Outstation in Pune with Rising Cab Service for comfortable long-distance travel. Our buses are ideal for corporate outings, pilgrimages, family vacations, educational tours, and weekend trips with professional drivers and affordable pricing."
},
{
name: "Shivswaraj Bus Hire Service Pune",
description: "Rising Cab Service provides Shivswaraj Bus Hire Service Pune with well-maintained buses suitable for weddings, group tours, school excursions, and corporate transportation. Enjoy safe travel, comfortable seating, and dependable service."
},
{
name: "32 Seater Bus Rate Per Km in Pune",
description: "Get competitive 32 Seater Bus Rate Per Km in Pune with Rising Cab Service. We offer transparent pricing, flexible rental plans, experienced drivers, and comfortable buses for local and outstation travel."
},
{
name: "35 Seater Bus on Rent in Pune",
description: "Hire a 35 Seater Bus on Rent in Pune for family functions, group tours, corporate travel, weddings, and educational trips. Our buses provide spacious seating, clean interiors, and reliable transportation."
},
{
name: "35 Seater Tourist Bus Near Me in Pune",
description: "Book a 35 Seater Tourist Bus Near Me in Pune for sightseeing tours, holiday travel, pilgrimage trips, and weekend getaways. We ensure comfortable travel with professional chauffeur support."
},
{
name: "35 Seater Tourist Bus for Outstation in Pune",
description: "Rising Cab Service offers 35 Seater Tourist Bus for Outstation in Pune with comfortable seating, luggage space, and safe travel arrangements for long-distance group journeys."
},
{
name: "35 Seater Bus for Corporate Office in Pune",
description: "Choose a 35 Seater Bus for Corporate Office in Pune for employee transportation, business events, conferences, and daily staff commuting with reliable and punctual service."
},
{
name: "35 Seater Bus for Corporate Outing in Pune",
description: "Book a 35 Seater Bus for Corporate Outing in Pune for team-building events, company picnics, meetings, and business travel with comfortable seating and professional drivers."
},
{
name: "40 Seater Tourist Bus Near Me Pune",
description: "Rising Cab Service offers 40 Seater Tourist Bus Near Me Pune for large group travel, sightseeing tours, religious tours, weddings, and holiday trips with safe and comfortable transportation."
},
{
name: "40 Seater Bus Rent Per Km in Pune",
description: "Get affordable 40 Seater Bus Rent Per Km in Pune with transparent pricing, experienced drivers, and well-maintained buses suitable for local and outstation travel."
},
{
name: "40 Seater Bus on Rent in Pune",
description: "Book a 40 Seater Bus on Rent in Pune for corporate events, educational tours, family functions, and group outings. Our buses offer spacious seating and dependable transportation."
},
{
name: "40 Seater Bus on Rent in Pune for Wedding",
description: "Hire a 40 Seater Bus on Rent in Pune for Wedding functions to comfortably transport guests between venues with punctual service and professional chauffeur support."
},
{
name: "45 Seater Bus Near Me for Rent",
description: "Rising Cab Service provides 45 Seater Bus Near Me for Rent for large group transportation, corporate travel, family events, and outstation tours with comfortable travel facilities."
},
{
name: "45 Seater Bus for School Trip",
description: "Book a 45 Seater Bus for School Trip with safety-focused transportation, experienced drivers, spacious seating, and reliable service for educational excursions and student tours."
},
{
name: "45 Seater Bus Price Per Km in Pune",
description: "Get competitive 45 Seater Bus Price Per Km in Pune with affordable rental packages, professional drivers, and well-maintained buses for all travel requirements."
},
{
name: "50 Seater Bus Rental Services in Pune",
description: "Rising Cab Service offers 50 Seater Bus Rental Services in Pune for weddings, corporate events, pilgrimages, educational tours, and large group travel with premium transportation facilities."
},
{
name: "50 Seater Bus for Corporate Outing Near Me",
description: "Book a 50 Seater Bus for Corporate Outing Near Me for employee travel, team outings, conferences, and business events with spacious seating and professional service."
},
{
name: "50 Seater Bus Hire in Pune",
description: "Hire a 50 Seater Bus in Pune for long-distance travel, sightseeing tours, family functions, and group transportation with comfortable seating and experienced drivers."
},
{
name: "32 35 40 45 50 Seater Bus on Rent in Pune for Family",
description: "Rising Cab Service offers 32, 35, 40, 45, and 50 Seater Bus on Rent in Pune for Family trips, weddings, pilgrimages, vacations, and special events with customized rental packages and reliable transportation."
},
{
name: "32 35 40 45 50 Seater Bus on Rent in Pimpri Chinchwad",
description: "Book 32, 35, 40, 45, and 50 Seater Bus on Rent in Pimpri Chinchwad for local travel, family tours, corporate transportation, and outstation journeys with professional drivers and affordable rates."
},
{
name: "32 35 40 45 50 Seater Bus for Outstation Trip",
description: "Choose 32, 35, 40, 45, and 50 Seater Bus for Outstation Trip for comfortable long-distance travel to destinations across Maharashtra, Goa, Karnataka, and other locations."
},
{
name: "32 35 40 45 50 Seater Bus for Corporate Trip",
description: "Rising Cab Service provides 32, 35, 40, 45, and 50 Seater Bus for Corporate Trip requirements including conferences, employee transportation, corporate outings, seminars, and business events."
}
],

tableData: [
["32 Seater Bus Hire Near Me in Pune","32 Seater Bus Hire for Outstation in Pune"],
["Shivswaraj Bus Hire Service Pune","32 Seater Bus Rate Per Km in Pune"],
["35 Seater Bus on Rent in Pune","35 Seater Tourist Bus Near Me in Pune"],
["35 Seater Tourist Bus for Outstation in Pune","35 Seater Bus for Corporate Office in Pune"],
["35 Seater Bus for Corporate Outing in Pune","40 Seater Tourist Bus Near Me Pune"],
["40 Seater Bus Rent Per Km in Pune","40 Seater Bus on Rent in Pune"],
["40 Seater Bus on Rent in Pune for Wedding","45 Seater Bus Near Me for Rent"],
["45 Seater Bus for School Trip","45 Seater Bus Price Per Km in Pune"],
["50 Seater Bus Rental Services in Pune","50 Seater Bus for Corporate Outing Near Me"],
["50 Seater Bus Hire in Pune","32 35 40 45 50 Seater Bus on Rent in Pune for Family"],
["32 35 40 45 50 Seater Bus on Rent in Pimpri Chinchwad","32 35 40 45 50 Seater Bus for Outstation Trip"],
["32 35 40 45 50 Seater Bus for Corporate Trip","50 Seater Bus Hire in Pune"]
],




whychoose: [
    {
        WhyChooseheading: "32, 35, 40, 45 & 50 Seater Bus on Rent in Pune",
        WhyChoosedescription: "Rising Cab Service provides comfortable bus rental services in Pune with 32, 35, 40, 45, and 50 seater buses for group transportation and large-scale travel requirements."
    },
    {
        WhyChooseheading: "Perfect for Corporate and Employee Transportation",
        WhyChoosedescription: "Our buses are widely used for corporate events, employee transportation, industrial visits, conferences, seminars, and company outings."
    },
    {
        WhyChooseheading: "Ideal for School and College Trips",
        WhyChoosedescription: "Educational institutions regularly hire our buses for school excursions, educational tours, picnics, industrial visits, and student transportation."
    },
    {
        WhyChooseheading: "Suitable for Weddings and Family Functions",
        WhyChoosedescription: "Large seater buses are perfect for wedding guest transportation, family gatherings, social events, and destination wedding travel."
    },
    {
        WhyChooseheading: "Available for Local and Outstation Travel",
        WhyChoosedescription: "Our buses are available for Pune city travel and outstation destinations including Mahabaleshwar, Goa, Shirdi, Nashik, Kolhapur, Konkan, Lonavala, and other tourist locations."
    },
    {
        WhyChooseheading: "AC and Non-AC Bus Options Available",
        WhyChoosedescription: "Customers can choose from air-conditioned and non-air-conditioned buses according to travel preferences, group requirements, and budget."
    },
    {
        WhyChooseheading: "Pickup Available Across Pune & PCMC",
        WhyChoosedescription: "Bus pickup services are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Pimpri Chinchwad, Wagholi, and surrounding areas."
    },
    {
        WhyChooseheading: "Experienced Drivers and Well-Maintained Fleet",
        WhyChoosedescription: "Our professional drivers and regularly serviced buses ensure safe travel, punctual service, passenger comfort, and a smooth journey."
    }
]
};

const faqData = [
    {
        question: "Which bus seating capacities are available on rent in Pune?",
        answer: "We provide 32 Seater, 35 Seater, 40 Seater, 45 Seater, and 50 Seater buses for local and outstation travel."
    },
    {
        question: "Can I hire a bus for outstation trips from Pune?",
        answer: "Yes, buses are available for outstation destinations across Maharashtra and neighboring states."
    },
    {
        question: "Do you provide AC buses for group travel?",
        answer: "Yes, both AC and Non-AC buses are available according to customer requirements."
    },
    {
        question: "Can corporate companies hire buses for employee transportation?",
        answer: "Yes, we provide buses for employee transportation, company events, conferences, and corporate outings."
    },
    {
        question: "Are buses available for school and college trips?",
        answer: "Yes, buses can be booked for educational tours, industrial visits, picnics, and student excursions."
    },
    {
        question: "Can I hire a bus for wedding guest transportation?",
        answer: "Yes, our buses are commonly used for wedding functions, family events, and guest transportation."
    },
    {
        question: "Do you provide buses for pilgrimage tours?",
        answer: "Yes, buses are available for Shirdi, Ashtavinayak, Pandharpur, Tuljapur, Akkalkot, Jyotirlinga, and other religious tours."
    },
    {
        question: "Are drivers included with the bus rental service?",
        answer: "Yes, all bus rentals include experienced and professional drivers."
    },
    {
        question: "Can I book a bus for multiple-day tours?",
        answer: "Yes, buses can be hired for one-day trips, weekend tours, and multi-day travel packages."
    },
    {
        question: "How can I book a 32, 35, 40, 45, or 50 Seater Bus on Rent in Pune?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, website inquiries, or online booking forms with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Suresh Chavan",
        feedback:
            "We hired a 45 Seater Bus for our company outing to Mahabaleshwar. The bus was clean, comfortable, and the entire group enjoyed a safe and pleasant journey.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Manisha Patwardhan",
        feedback:
            "Our family booked a 35 Seater Bus for a wedding function. The vehicle arrived on time, the driver was professional, and transportation was managed perfectly.",
        rating: 5
    }
];



    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];









const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "32, 35, 40, 45, 50 Seater Bus on Rent in Pune",
"image": "https://www.risingcabservice.com/assets/images/bus-rental-pune.jpg",
"description": "Book 32, 35, 40, 45, and 50 Seater Bus on Rent in Pune with Rising Cab Service for weddings, corporate travel, school trips, and outstation tours. Comfortable AC tourist buses with professional drivers for large group transportation.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹35/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/bus-on-rent-in-pune"
}
};







    return (
        <div>

<Helmet>
  <title>Bus on Rent in Pune | 32–50 Seater Tourist Bus | +91 9272511548</title>

<meta
 name="description"
 content="Book 32, 35, 40, 45, and 50 Seater Bus on Rent in Pune for weddings, corporate trips, school tours, and outstation travel. AC tourist buses available for large groups."
/>

<meta
 name="keywords"
 content="32 seater bus on rent in pune, 35 seater bus hire pune, 40 seater bus on rent pune, 45 seater bus for school trip pune, 50 seater bus rental pune, tourist bus pune, corporate bus hire pune, wedding bus rental pune, shivswaraj bus hire pune, shivswaraj holidays pune bus"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>




            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/90.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Multiseaterbuses;